var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Classes.MenuPromise = new Class({
    Implements: Class.Thenable,
    resetThenable: function(){
        throw new TypeError('A promise can only be resolved once.');
    }
});
